import { useTr } from "@/i18n";

const stats = [
  "25+ Anni di Carriera",
  "1500+ Eventi Realizzati",
  "Impianto Audio & Luci Professionale",
  "Feste di Paese & Club in Svizzera",
  "Fontane Fredde & Effetti Speciali",
  "Producer & Custom Edits",
];

export default function StatsBar() {
  const tr = useTr();
  const items = tr("stats.items", stats);
  const row = [...items, ...items];
  return (
    <div
      data-testid="stats-marquee"
      className="relative overflow-hidden border-y border-[rgba(226,184,87,0.25)] bg-[#0A0A0A] py-8"
    >
      <div className="marquee-track flex w-max items-center gap-16">
        {row.map((s, i) => (
          <span key={i} className="flex items-center gap-16 whitespace-nowrap">
            <span
              className={`font-display text-3xl sm:text-4xl font-semibold uppercase tracking-wide ${
                i % 2 ? "text-outline-gold" : "text-[#E2B857]"
              }`}
            >
              {s}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#BFA45D]" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
